import { NgModule } from '@angular/core'
import { FloCssClassSanitizePipe } from './css-class-sanitize.pipe'

@NgModule({
  declarations: [FloCssClassSanitizePipe],
  exports: [FloCssClassSanitizePipe]
})
export class FloCssClassSanitizePipeModule {}
